import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ShapesInterface } from '@app/shared/models/shapes.model';
import { Feature, StopsInterface } from '@app/shared/models/stops.model';
import { BusService } from '@app/shared/services/bus.service';
import { RequestDestroyService } from '@app/shared/services/request-destroy.service';
import { NGXLogger } from 'ngx-logger';
import { first } from 'rxjs/operators';
import { MapService } from '../map/map-services/map.service';
import { NoticesService } from '@app/shared/services/notices.service';
import { Notice } from '@app/shared/models/notices.model';
import { Observable } from 'rxjs';

@Component({
  selector: 'ty-stops',
  templateUrl: './stops.component.html',
  styleUrls: ['./stops.component.scss'],
})
export class StopsComponent implements OnInit {
  searchValue = '';
  busId!: number;
  busname!: string;
  busCode!: string;
  color!: string;
  stopsList!: StopsInterface;
  stopsListFilter!: Feature[];
  shapesList!: ShapesInterface;
  firstStop!: string;
  lastStop!: string;
  namesOfBusLine!: string[];
  direction = 0;
  isVisibleDataSearchError = false;
  isReverseDirection = false;
  isVisibleSpinnerSearch = true;
  notices: Notice[] = [];

  constructor(
    private logger: NGXLogger,
    private route: ActivatedRoute,
    private busService: BusService,
    private mapService: MapService,
    private noticesService: NoticesService,
    private router: Router,
    private requestDestroyService: RequestDestroyService
  ) {}

  ngOnInit(): void {
    this.busId = Number(this.route.snapshot.queryParamMap.get('bus'));
    this.busname = String(this.route.snapshot.queryParamMap.get('busName'));
    this.busCode = String(this.route.snapshot.queryParamMap.get('busCode'));
    this.color = String(this.route.snapshot.queryParamMap.get('color'));
    this.getNoticesFromBus();

    if (this.route.snapshot.queryParamMap.get('dir')) {
      this.direction = Number(this.route.snapshot.queryParamMap.get('dir'));
      this.isReverseDirection = this.direction === 1 ? true : false;
    }

    if (
      this.busId &&
      this.busId > 0 &&
      this.busname &&
      this.busname.length > 0 &&
      this.busCode &&
      this.busCode.length > 0
    ) {
      this.getStopsFromBus(this.busId);
      this.getShapesFromBus(this.busId);
    } else {
      this.logger.error(`Faltan datos: ${this.busId}  /  ${this.busname} /
      ${this.busCode}  /  ${this.color}`);
      this.returnToBus();
    }
  }

  getNoticesFromBus() {
    // this.noticesService.getNotices()
    //   .subscribe( notices => this.notices = notices);
    var noticesFake;
    noticesFake = [
      {
        IdAviso: 4,
        IdEmpresa: 2,
        CConces: 300,
        Codlinea: '2',
        Tipo: 'II',
        Texto: 'Demo - Retrasos en la linea - Demo',
      },
      {
        IdAviso: 3,
        IdEmpresa: 5,
        CConces: 232,
        Codlinea: '1',
        Tipo: 'I',
        Texto: 'Demo AVSA',
      },
    ];

    noticesFake.forEach((notices) => {
      if (notices.Codlinea == this.busId.toString()) {
        this.notices.push(notices);
      }
      return;
    });
  }

  getStopsFromBus(busId: number): void {
    this.direction = this.isReverseDirection ? 1 : 0;
    this.isVisibleSpinnerSearch = true;
    this.busService
      .getStopsList(busId, this.direction)
      .pipe(first())
      .subscribe(
        (res: StopsInterface) => {
          this.stopsList = res;
          // console.log("stopsFromBus", this.stopsList);
          this.sendBusStops(this.stopsList);

          if (this.stopsList.features.length > 0) {
            if (!this.isReverseDirection) {
              this.namesOfBusLine = this.busname.split('-');
              this.firstStop = this.namesOfBusLine[0];
              this.lastStop = this.namesOfBusLine[1];
            } else {
              this.namesOfBusLine = this.busname.split('-');
              this.firstStop = this.namesOfBusLine[1];
              this.lastStop = this.namesOfBusLine[0];
            }

            // Call the filter
            this.setFilterValue();
          } else {
            this.logger.error(`Empty object at getStopsFromBus`);
            this.namesOfBusLine = this.busname.split('-');
            this.firstStop = this.namesOfBusLine[0];
            this.lastStop = this.namesOfBusLine[1];
          }

          this.isVisibleSpinnerSearch = false;
        },
        (err) => {
          this.logger.error(`Error al cargar las paradas en: getStopsFromBus ${err.message}`);
        }
      );
  }

  getShapesFromBus(busId: number): void {
    this.busService
      .getShapesList(busId)
      .pipe(first())
      .subscribe(
        (res: ShapesInterface) => {
          this.shapesList = res;
          this.sendBusShapes(this.shapesList);
        },
        (err) => {
          this.logger.error(`Error al cargar los lineas en: getShapesFromBus()
        ${err.message}`);
        }
      );
  }

  sendBusStops(stopsList: StopsInterface): void {
    this.mapService.setStopPoints(stopsList);
  }

  sendBusShapes(shapesList: ShapesInterface): void {
    this.mapService.setShapesPoints(shapesList);
  }

  backClicked(): void {
    this.requestDestroyService.destroy$.next();
    if (this.router.url.includes(this.busService.simulatePath)) {
      this.router.navigate([this.busService.simulatePath], {});
    } else {
      this.router.navigate(['/'], {});
    }
  }

  revertDirection(): void {
    this.isReverseDirection = !this.isReverseDirection;

    const auxData: string = this.firstStop;
    this.firstStop = this.lastStop;
    this.lastStop = auxData;

    this.getStopsFromBus(this.busId);
  }

  goToTimesLines(stop: Feature): void {
    if (this.router.url.includes(this.busService.simulatePath)) {
      this.router.navigate([this.busService.simulatePath, 'times'], {
        queryParams: {
          bus: this.busId,
          busName: this.busname,
          busCode: this.busCode,
          stop: stop.properties.stop_id,
          stopName: stop.properties.stop_name,
          dir: this.isReverseDirection ? 1 : 0,
          stopCode: stop.properties.stop_code,
        },
      });
    } else {
      this.router.navigate(['times'], {
        queryParams: {
          bus: this.busId,
          busName: this.busname,
          busCode: this.busCode,
          stop: stop.properties.stop_id,
          stopName: stop.properties.stop_name,
          dir: this.isReverseDirection ? 1 : 0,
          stopCode: stop.properties.stop_code,
        },
      });
    }
  }

  returnToBus(): void {
    if (this.router.url.includes(this.busService.simulatePath)) {
      this.router.navigate(['/' + this.busService.simulatePath], {});
    } else {
      this.router.navigate(['/'], {});
    }
  }

  setFilterValue(): void {
    this.isVisibleDataSearchError = false;
    this.isVisibleSpinnerSearch = true;
    const dataFilter: Feature[] = [];

    if (this.stopsList.features) {
      this.stopsList.features.forEach((element) => {
        try {
          console.log('element', element);
          if (!element.properties.stop_name) {
            element.properties.stop_name = `Parada (${element.properties.stop_code})`;
          }
          const stringSearch = element.properties.stop_name.toLocaleLowerCase();
          const filteredString = stringSearch.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
          const inputSearchFiltered = this.searchValue
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');

          if (filteredString.indexOf(inputSearchFiltered.toLowerCase()) > -1) {
            dataFilter.push(element);
          }
        } catch (error) {
          console.log('Error ', error, ' element:', element);
        }
      });
      this.stopsListFilter = dataFilter;
    }

    if (this.stopsListFilter.length < 1) {
      this.isVisibleDataSearchError = true;
    }

    this.isVisibleSpinnerSearch = false;
  }

  clearSearch(): void {
    this.searchValue = '';
    this.setFilterValue();
  }
}
